import Card from "../../shared/Card"
const ReactHistory = () => {
    return (
        <div className="demo-container">
            <Card title="History of React" subtext="Verions" description="What Changed in What Versions can be found here : https://github.com/facebook/react/blob/main/CHANGELOG.md"/>
        </div>
    )
}

export default ReactHistory